import { TOGGLE_PRICE_AREA } from "./showPriceAreaReducer"

export const togglePriceAreaOnMap = (value) => ({
    type: TOGGLE_PRICE_AREA,
    payload: value
})